import React from 'react';
import clsx from 'clsx';
import Hero from './Hero';
import About from './About';
import OnAir from './OnAir';
import OtetsutabiList from './OtetsutabiList';
import Partners from './Partners';
import Footer from '../../../front/Footer/Footer';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Register from './Register';
import BackgroundEdgeImage from '../../../../images/features/local_delivery/background_edge.png';
import ShareButtons from './ShareButtons';
import TableOfContents from './TableOfContents';
import { TYPOGRAPHY_COLOR } from '../constants';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    color: TYPOGRAPHY_COLOR,
    fontSize: theme.typography.pxToRem(15),
  },
  background: {
    position: 'absolute',
    height: '100%',

    backgroundImage: `url(${BackgroundEdgeImage})`,
    backgroundRepeat: 'repeat-y',
    backgroundSize: 'contain',
    transform: 'rotateZ(180deg)',
    width: 24,
    [theme.breakpoints.up('sm')]: {
      width: 32,
    },
  },
  backgroundRight: {
    right: 0,
    transform: 'rotateZ(0deg)',
  },
  inner: {
    padding: theme.spacing(0, 3),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 4),
    },
  },
  footer: {
    paddingTop: 0,
  },
}));

const LocalDeliveryComponent = ({ plans, onAirList, authenticated }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.background} />
      <div className={clsx(classes.background, classes.backgroundRight)} />
      <ShareButtons />
      <div className={classes.inner}>
        <Hero authenticated={authenticated} />
        <TableOfContents />
        <About />
        <Register authenticated={authenticated} />
        <OnAir />
        <OtetsutabiList
          plans={plans}
          onAirList={onAirList}
          authenticated={authenticated}
        />
        <Register authenticated={authenticated} />
        <Partners />
        <Footer classes={{ root: classes.footer }} />
      </div>
    </div>
  );
};

export default LocalDeliveryComponent;
